var map = {
	"./1/symbol_0.png": "e7d9",
	"./1/symbol_1.png": "e2cd",
	"./1/symbol_10.png": "f0a7",
	"./1/symbol_11.png": "12cb",
	"./1/symbol_12.png": "8b1e",
	"./1/symbol_2.png": "8592",
	"./1/symbol_3.png": "017d",
	"./1/symbol_4.png": "bc57",
	"./1/symbol_5.png": "bbeb",
	"./1/symbol_6.png": "9594",
	"./1/symbol_7.png": "66a1",
	"./1/symbol_8.png": "1086",
	"./1/symbol_9.png": "fd1c",
	"./2/symbol_0.png": "6a1f",
	"./2/symbol_1.png": "a384",
	"./2/symbol_10.png": "7093",
	"./2/symbol_11.png": "4b6a",
	"./2/symbol_12.png": "3baa",
	"./2/symbol_2.png": "03c5",
	"./2/symbol_3.png": "3f13",
	"./2/symbol_4.png": "fbb0",
	"./2/symbol_5.png": "42e1",
	"./2/symbol_6.png": "c9d4",
	"./2/symbol_7.png": "bea4",
	"./2/symbol_8.png": "4ce1",
	"./2/symbol_9.png": "790b",
	"./3/symbol_0.png": "735f",
	"./3/symbol_1.png": "953c",
	"./3/symbol_10.png": "df28",
	"./3/symbol_12.png": "1cad",
	"./3/symbol_2.png": "d8bb",
	"./3/symbol_3.png": "ff94",
	"./3/symbol_4.png": "53237",
	"./3/symbol_5.png": "dfee",
	"./3/symbol_6.png": "3385",
	"./3/symbol_7.png": "0875",
	"./3/symbol_8.png": "9e35",
	"./3/symbol_9.png": "94b5",
	"./4/symbol_0.png": "09028",
	"./4/symbol_1.png": "7031",
	"./4/symbol_10.png": "750c",
	"./4/symbol_12.png": "d1fc",
	"./4/symbol_2.png": "7fec",
	"./4/symbol_3.png": "92c5",
	"./4/symbol_4.png": "2825",
	"./4/symbol_5.png": "9adc",
	"./4/symbol_6.png": "e33a",
	"./4/symbol_7.png": "487a",
	"./4/symbol_8.png": "8d6d",
	"./4/symbol_9.png": "61dc",
	"./gamble/btn_HIGH_lose.png": "4090",
	"./gamble/btn_HIGH_normal.png": "60a8",
	"./gamble/btn_HIGH_win.png": "40d6",
	"./gamble/btn_LOW_lose.png": "6bbb",
	"./gamble/btn_LOW_normal.png": "66db",
	"./gamble/btn_LOW_win.png": "4fdc",
	"./gamble/btn_collect.png": "ff64",
	"./gamble/history_lose.png": "477c",
	"./gamble/history_win.png": "eb4c",
	"./gamble/wheel_HIGH_lose.png": "9c08",
	"./gamble/wheel_HIGH_win.png": "8b20",
	"./gamble/wheel_LOW_lose.png": "f478",
	"./gamble/wheel_LOW_win.png": "395d",
	"./gold1.png": "0d69",
	"./gold2.png": "b697",
	"./gold3.png": "e7c7",
	"./gold4.png": "10865",
	"./header_slotmachine_freespin._no_fg.png": "ca8ea",
	"./silver1.png": "7ecb",
	"./silver2.png": "bcbc",
	"./silver3.png": "df8f",
	"./silver4.png": "0c90",
	"./slotmachine.png": "0c3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f410";